var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGraduacionAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343 938 c-184 -107 -263 -158 -263 -170 0 -21 15 -31 295 -194 170 -99 228 -128 255 -128 27 0 95 35 288 148 140 82 256 155 259 163 3 8 -1 21 -8 28 -30 29 -504 297 -533 301 -26 4 -74 -20 -293 -148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128 652 l-28 -17 0 -127 c0 -102 -3 -132 -17 -157 -16 -28 -17 -33 -3 -58 11 -20 25 -29 49 -31 59 -6 91 48 56 94 -11 15 -14 53 -15 167 0 81 -3 147 -7 146 -5 0 -20 -8 -35 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 482 c0 -60 5 -94 14 -108 15 -21 242 -156 285 -169 50 -15 130 -6 183 20 123 62 234 134 246 160 11 25 17 185 7 185 -3 0 -76 -40 -162 -90 -140 -81 -162 -90 -206 -90 -45 0 -66 9 -203 90 -84 50 -155 90 -158 90 -3 0 -6 -39 -6 -88z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGraduacionAlt);
export default __webpack_public_path__ + "static/media/logo-graduacion-alt.eb682995b9ca17a3d2c1ce1b895a427e.svg";
export { ForwardRef as ReactComponent };